import { privilagesURLs } from "../data/constants";
import { getJson, postJson } from "../utils/httpService";

async function getUserPrivileges(loginId, token) {
  try {
    return await getJson(
      privilagesURLs.getUserPrivileges + `/${loginId}`,
      token
    );
  } catch (e) {
    throw e;
  }
}

async function editUserPrivileges(data, token) {
  try {
    return await postJson(
      privilagesURLs.editUserPrivileges,
      {
        loginId: data.loginId,
        privilegeCode: data.privilegeCode,
      },
      token
    );
  } catch (e) {
    throw e;
  }
}

export { getUserPrivileges, editUserPrivileges };
